var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("router-view"),
      _vm._v(" "),
      _c("toast", { ref: "toast" }),
      _vm._v(" "),
      _c("mymodal", { ref: "modal" }),
      _vm._v(" "),
      _c("div", { staticClass: "fixed-all", attrs: { id: "fiexd" } }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "fixed-2", on: { click: _vm.toTop } }, [
          _c("i", { staticClass: "ico ico3" }),
          _vm._v(" "),
          _c("p", [_vm._v("返回顶部")])
        ])
      ]),
      _vm._v(" "),
      _c("a", { attrs: { href: "/", id: "download" } }),
      _vm._v(" "),
      _c(
        "Modal",
        {
          ref: "concat",
          model: {
            value: _vm.concat,
            callback: function($$v) {
              _vm.concat = $$v
            },
            expression: "concat"
          }
        },
        [
          _c(
            "div",
            { staticStyle: { width: "100%", "text-align": "center" } },
            [
              _c("img", {
                staticStyle: { width: "300px", height: "300px" },
                attrs: { src: require("./assets/images/storlead_kf.png") }
              })
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "Button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      _vm.concat = false
                    }
                  }
                },
                [_vm._v("关闭")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "fixed-1" }, [
      _c("div", { staticClass: "main app" }, [
        _c("i", { staticClass: "ico ico1" }),
        _vm._v(" "),
        _c("p", [_vm._v("在线客服")]),
        _vm._v(" "),
        _c("div", { staticClass: "ewm" }, [
          _c("img", {
            staticStyle: { width: "250px", height: "250px" },
            attrs: { src: require("./assets/images/storlead_kf.png") }
          }),
          _vm._v(" "),
          _c("span", { staticClass: "arrow" })
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "main lx" }, [
        _c("i", { staticClass: "ico ico2" }),
        _vm._v(" "),
        _c("p", [_vm._v("联系电话")]),
        _vm._v(" "),
        _c("div", { staticClass: "phone" }, [
          _c("i"),
          _vm._v(" "),
          _c("span", [_vm._v("0755-83258725")]),
          _vm._v(" "),
          _c("span", { staticClass: "arrow" })
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ba5bd90", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ba5bd90","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 7HvE
// module chunks = 47